<template>
  <PanelV2 type="w7" mode="simple">
    <template v-slot:content-solt>
      <img :src="statusData.icon" alt="" />
      <span class="title">{{statusData.title}}</span>
      <span class="sub-title" v-if="isType">Would you like to resume your application?</span>
      <span class="hotline" v-if="!isType"><p>For any concerns, please contact our</p>
      <a @click="openDialog">Merchant Services Hotline</a>
      </span>
      <!-- <el-button v-if="!isType" type="primary" @click="toIndex()">{{statusData.btntitle}}</el-button> -->
      <div class="btnBox" v-if="isType">
        <el-button @click="toIndex()">No, I'll do it later</el-button>
        <el-button type="primary" @click="toPage()">Yes, I'll resume</el-button>
      </div>
      <HotLinePop v-if="showDialog" @closeDialog="closeDialog" />
    </template>
  </PanelV2>
</template>

<script>
const processNoName = {
  '1': 'Individual',
  '2': 'Sole Proprietorship',
  '3': 'Corporation',
  '4': 'Partnership',
  '5': 'BDO Merchant',
}
import HotLinePop from "../components/HotLinePop.vue";
import API from "@/api"
export default {
  name: "CheckStatus",
  components: {
    HotLinePop,
  },
  data() {
    return {
      showDialog: false,
      statusData: {},
      statusType: {
        '0': {
          icon: require('@/assets/pc/pending-filled@3x.png'),
          title: `Your ${processNoName[this.$route.query.processNo]} merchant application is still incomplete.`,
          btntitle: 'Okay'
        },
        '1': {
          icon: require('@/assets/pc/success-filled@2x.png'),
          title: 'Your application has been approved.',
          btntitle: 'Okay'
        },
        '2': {
          icon: require('@/assets/pc/error-filled@2x.png'),
          title: 'Your application has been declined.',
          btntitle: 'Okay'
        },
        '3': {
          icon: require('@/assets/pc/error-filled@2x.png'),
          title: 'Your application has been cancelled.',
          btntitle: 'Okay'
        },
        '4': {
          icon: require('@/assets/pc/error-filled@2x.png'),
          title: 'Your application has been cancelled.',
          btntitle: 'Okay'
        },
        '7': {
          icon: require('@/assets/pc/pending-filled@2x.png'),
          title: 'Your application is still in progress.',
          btntitle: 'Okay'
        },
      }
    };
  },
  created() {
    this.statusData = this.statusType[this.$route.query.status]
  },
  computed: {
    isType() {
      return this.$route.query.status == '0'
    }
  },
  methods: {
    toIndex() {
      this.goBackAppIndex()
      // this.$router.push({ path: "/check-mid-process" });
    },
    toPage() {
      API.getBdoProcessData({
        pageNo: '0',
        token: this.getCookieItem('token')
      }).then(res => {
        const { obj: { personalInfo } } = res;
        const fullName = `${personalInfo.firstName || ''} ${personalInfo.middleName || ''} ${personalInfo.lastName || ''} ${personalInfo.suffix || ''}`
        this.$router.push({ name: this.$route.query.name, params: { type: 'showDialog', name: this.$route.query.name, fullName: fullName } });
      })
    },
    openDialog() {
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.panel-v2 {
  height: 561px;
  text-align: center;

  img {
    margin: 45px 0 0;
    width: 144px;
  }

  .title {
    margin: 32px 0 0;
    font: normal normal normal 24px/40px Nunito-bold;
    letter-spacing: 0px;
    color: #2e2e2e;
  }

  .sub-title {
    margin: 16px 0 0;
    font: normal normal normal 16px/24px Nunito;
    letter-spacing: 0px;
    color: #2e2e2e;
  }
  .hotline {
    margin-top: 60px;
    margin-bottom: 60px;
  }
  a {
    color: #0072d8;
    text-decoration: underline;
    cursor: pointer;
  }
  .el-button {
    width: 318px;
  }
  .btnBox {
    margin-top: 114px;
    .el-button {
      width: 158px;
    }
  }
}
</style>
